import { useSelect } from '@/pages/activity/boat/api';
import { Select, SelectProps } from '@arco-design/web-react';
import React from 'react';

export const SelectBoat = ({ value, onChange, placeholder = '全部', ...rest }: SelectProps) => {
  const { data, isLoading } = useSelect({
    params: {
      pageSize: 100,
      pageIndex: 1,
    },
  });

  const options = data
    ? data.data.items.map((v) => ({
        label: v.name,
        value: v.id,
      }))
    : [];
  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      loading={isLoading}
      {...rest}
      options={options}
      allowClear
    />
  );
};
